document.addEventListener('DOMContentLoaded', () => {
    const accordionRoots = document.querySelectorAll('.about-infromation-block .accordion');

    const getTransitionDuration = (element) => {
        const styles = window.getComputedStyle(element);
        const durations = styles.transitionDuration.split(',');
        const delays = styles.transitionDelay.split(',');

        return durations.reduce((longestDuration, duration, index) => {
            const durationInMilliseconds = duration.includes('ms')
                ? parseFloat(duration)
                : parseFloat(duration) * 1000;
            const delay = delays[index] || delays[delays.length - 1] || '0s';
            const delayInMilliseconds = delay.includes('ms')
                ? parseFloat(delay)
                : parseFloat(delay) * 1000;

            return Math.max(longestDuration, durationInMilliseconds + delayInMilliseconds);
        }, 0);
    };

    const setExpandedState = (item, isExpanded) => {
        const header = item.querySelector('.accordion__header');
        const body = item.querySelector('.accordion__body');

        header.setAttribute('aria-expanded', String(isExpanded));
        body.setAttribute('aria-hidden', String(!isExpanded));

        if (isExpanded) {
            body.removeAttribute('inert');
        } else {
            body.setAttribute('inert', '');
        }
    };

    const closeItem = (item) => {
        const body = item.querySelector('.accordion__body');

        body.style.maxHeight = `${body.scrollHeight}px`;
        body.offsetHeight;
        item.classList.remove('active');
        setExpandedState(item, false);
        body.style.maxHeight = '0px';
    };

    const openItem = (item) => {
        const body = item.querySelector('.accordion__body');

        item.classList.add('active');
        setExpandedState(item, true);
        body.style.maxHeight = `${body.scrollHeight}px`;

        if (getTransitionDuration(body) === 0) {
            window.requestAnimationFrame(() => {
                if (item.classList.contains('active')) {
                    body.style.maxHeight = 'none';
                }
            });
        }
    };

    const stabilizeHeaderPosition = (header, initialTop, duration) => {
        let animationFrame = null;
        let isStopped = false;
        const startedAt = performance.now();
        const interruptionEvents = ['keydown', 'pointerdown', 'touchstart', 'wheel'];

        const stop = () => {
            if (isStopped) {
                return;
            }

            isStopped = true;

            if (animationFrame !== null) {
                window.cancelAnimationFrame(animationFrame);
            }

            interruptionEvents.forEach((eventName) => {
                window.removeEventListener(eventName, stop, true);
            });
        };

        const keepPosition = (currentTime) => {
            if (isStopped) {
                return;
            }

            const positionDifference = header.getBoundingClientRect().top - initialTop;

            if (Math.abs(positionDifference) > 0.5) {
                window.scrollBy(0, positionDifference);
            }

            if (currentTime - startedAt < duration) {
                animationFrame = window.requestAnimationFrame(keepPosition);
            } else {
                stop();
            }
        };

        interruptionEvents.forEach((eventName) => {
            window.addEventListener(eventName, stop, {
                capture: true,
                passive: true
            });
        });

        animationFrame = window.requestAnimationFrame(keepPosition);

        return stop;
    };

    accordionRoots.forEach((accordion, accordionIndex) => {
        const items = Array.from(accordion.querySelectorAll('.accordion__item'));
        let cancelHeaderStabilization = null;

        items.forEach((item, itemIndex) => {
            const header = item.querySelector('.accordion__header');
            const body = item.querySelector('.accordion__body');
            const identifier = `${accordionIndex + 1}-${itemIndex + 1}`;

            header.id = header.id || `accordion-header-${identifier}`;
            body.id = body.id || `accordion-panel-${identifier}`;
            header.setAttribute('aria-controls', body.id);
            body.setAttribute('aria-labelledby', header.id);
            body.setAttribute('role', 'region');
            item.classList.remove('active');
            body.style.maxHeight = '0px';
            setExpandedState(item, false);

            body.addEventListener('transitionend', (event) => {
                if (
                    event.target === body
                    && event.propertyName === 'max-height'
                    && item.classList.contains('active')
                ) {
                    body.style.maxHeight = 'none';
                }
            });

            header.addEventListener('click', () => {
                if (cancelHeaderStabilization) {
                    cancelHeaderStabilization();
                    cancelHeaderStabilization = null;
                }

                const isOpen = item.classList.contains('active');

                if (isOpen) {
                    closeItem(item);
                    return;
                }

                const activeItem = items.find((currentItem) => currentItem.classList.contains('active'));
                const activeBody = activeItem
                    ? activeItem.querySelector('.accordion__body')
                    : null;
                const shouldStabilizeHeader = activeItem
                    && activeItem !== item
                    && Boolean(activeItem.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING);
                const initialHeaderTop = header.getBoundingClientRect().top;

                if (activeItem) {
                    closeItem(activeItem);
                }

                openItem(item);

                if (shouldStabilizeHeader) {
                    const transitionDuration = Math.max(
                        getTransitionDuration(body),
                        getTransitionDuration(activeBody)
                    );

                    cancelHeaderStabilization = stabilizeHeaderPosition(
                        header,
                        initialHeaderTop,
                        transitionDuration + 80
                    );
                }
            });
        });
    });
});
